import { api } from "./api";

/** MBS Supreme Ops — bağımsız operasyon komuta modülü */
export const supremeOps = {
    dashboard: () =>
        api.get("/v1/admin/operasyon/supreme-ops/dashboard/", { timeout: 90000 }).then((r) => r.data),
    oncelik: (params = {}) =>
        api.get("/v1/admin/operasyon/supreme-ops/oncelik/", { params }).then((r) => r.data),
    onayKuyrugu: (params = {}) =>
        api.get("/v1/admin/operasyon/supreme-ops/onay-kuyrugu/", { params }).then((r) => r.data),
    saglik: (params = {}) =>
        api.get("/v1/admin/operasyon/supreme-ops/saglik/", { params }).then((r) => r.data),
    brifing: () =>
        api.get("/v1/admin/operasyon/supreme-ops/brifing/", { timeout: 120000 }).then((r) => r.data),
    telemetri: () =>
        api.get("/v1/admin/operasyon/supreme-ops/telemetri/", { timeout: 90000 }).then((r) => r.data),
    aktivite: (params = {}) =>
        api.get("/v1/admin/operasyon/supreme-ops/aktivite/", { params }).then((r) => r.data),
    warRoom: (params = {}) =>
        api.get("/v1/admin/operasyon/supreme-ops/war-room/", { params, timeout: 60000 }).then((r) => r.data),
    calistir: (motor = "otonom") =>
        api.post("/v1/admin/operasyon/supreme-ops/calistir/", { motor }, { timeout: 180000 }).then((r) => r.data),
    topluIslem: (action, limit = 10) =>
        api.post("/v1/admin/operasyon/supreme-ops/toplu-islem/", { action, limit }).then((r) => r.data),
    topluOnay: (kaynak, limit = 10) =>
        api.post("/v1/admin/operasyon/supreme-ops/toplu-onay/", { kaynak, limit }).then((r) => r.data),
    onay: (payload) =>
        api.post("/v1/admin/operasyon/supreme-ops/onay/", payload).then((r) => r.data),
    saglikCoz: (uyariId) =>
        api.post("/v1/admin/operasyon/supreme-ops/saglik-coz/", { uyari_id: uyariId }).then((r) => r.data),
};
